export default __webpack_public_path__ + "static/inspire-growth-0c61dd53a590aba4e0084e3ff40656c8.svg";